export class BookStatus{

    static readonly Active = 1;
    static readonly Done = 2;
    static readonly Cancel = 3;
}